import axios from 'axios';

export const loginService = async ({username,password})=>{
  return new Promise((resolve, reject) => {
    axios.post(`${process.env.REACT_APP_URL_API}/auth/login`,{username,password})
      .then(res=>resolve(res))
      .catch(err => reject(err));
  });
}